import React, { useState, useRef, useEffect } from "react";
import { Tab, Nav, Form, Modal } from "react-bootstrap";
import Header from "../../Components/Header";
import OnboardingPendingCard from "../../../src/Pages/Onboarding/OnboardingPendingCard";
import OnboardingCompleted from "./OnboardingCompleted";
import OnboardingCreatedClient from "./OnboardingCreatedClient";
import OnboardingRejected from "./OnboardingRejected";
import OnboardingRaiseIssue from "./OnboardingRaiseIssue";
import OnboardingNotInterested from "./OnboardingNotInterested";
import Filter from "./Filter";
import Loader from "../../Components/Common/Loader";
import { useNavigate } from "react-router-dom";
import { Client_Search, Onboarding_Page } from "../../Configuration/API_URL";
import { Constants } from "../../CommonMethhods/Constants";
import SingleSignOnSideBar from "../../Components/SingleSignOnSideBar";
import { toast } from "react-toastify";
import SmallLoader from "../../Components/Common/smallLoader";
import {
  AESEncryption,
  ApiResDecrypt,
  decryptString,
} from "../../CommonMethhods/CommonMethods";
import { useDebounce } from "../../Components/useDebounce";
import OnboardingLeads from "./OnboardingLeads";
import moment from "moment";
import axiosInstance from "../../CommonMethhods/axiosInstance";

function OnboardingPendingNew(props) {
  const storeToken = localStorage.getItem("ssoToken");
  const userId = localStorage.getItem("userId");
  const [linecard, setLinecard] = useState("block-active col-division-5");
  const [loader, setLoader] = useState(false);
  const [tabStatus, setTabStatus] = useState("Created");
  const [search, setSearch] = useState();
  const [page, setPage] = useState(1);
  const [scrollLoader, setScrollLoader] = useState(false);
  const [filterData, setFilterData] = useState("HNI");
  const [onboardingData, setOnboardingData] = useState([]);
  const [rejectedData, setRejectedData] = useState([]);
  const [pendingData, setPendingData] = useState([]);
  const [serverError, setServerError] = useState(false);
  const [totalCount, setTotalCount] = useState();
  const [smallLoaderPdf, setPdfLoader] = useState(false);
  const [smallLoaderExcel, setExcelLoader] = useState(false);
  const debouncedValue = useDebounce(search, 1000);
  const [dayWiseDate, setDayWiseDate] = useState("yesterday");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [customDate, setCustomDate] = useState(false);
  const [selectedClient, setSelectedClient] = useState(null);
  const controllerRef = useRef(null);

  // const isFirstRender = useRef(true);

  // useEffect(() => {
  //   if (isFirstRender.current) {
  //     isFirstRender.current = false; // Skip first time
  //     return;
  //   }
  //   handleSearch(debouncedValue);
  // }, [debouncedValue]);

  useEffect(() => {
    handleSearch(debouncedValue);
  }, [debouncedValue]);

  useEffect(() => {
    if (!dayWiseDate) return;
    if (dayWiseDate === "custom-range") return;
    const { fromDate, toDate } = getDateRange(dayWiseDate);
    setFromDate(fromDate);
    setToDate(toDate);
    setCustomDate(false);
  }, [dayWiseDate]);

  useEffect(() => {
    if (!toDate) return;
    if (customDate) return; // 🚫 skip if in custom mode

    if (tabStatus === "Created" || tabStatus === "Leads") {
      onboardingApiData(page, tabStatus, "grid", 10);
    } else if (tabStatus === "Rejected") {
      rejectedOnboardingData(page, tabStatus, "grid", 10);
    } else if (tabStatus === "Pending") {
      pendingOnboardingData(page, tabStatus, "grid", 10);
    }
  }, [fromDate, toDate, tabStatus, page, customDate, filterData]);

  let navigate = useNavigate();
  localStorage.setItem("statusOfClient", tabStatus);
  if (storeToken == null) {
    window.location.replace("/");
    // localStorage.clear("");
  }
  function handleGridView(e) {
    if (linecard === "") setLinecard("block-active col-division-5");
  }

  function handleListView() {
    if (linecard === "block-active col-division-5") setLinecard("");
  }

  const handleRedirect = async (client) => {
    const decryptedMobile = client?.mobile && decryptString(client?.mobile);
    console.log(decryptedMobile, client, "decryptedMobile");
    

    const payloadValue = {
      mobile: decryptedMobile,
      userId: userId,
      clientType: filterData,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getLink = await axiosInstance.post(
        Onboarding_Page.EditDocument_URL,
        `"${encPayload}"`,
        //payloadValue,

      );
      //const res = getLink?.data;
      const res = ApiResDecrypt(getLink?.data);
      if (res.status === 0) {
        console.log(res?.data, "dataFound");
        
        window.open(res.data, "_blank", "noopener,noreferrer");
      } else {
        toast.error(res.message);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const onboardingApiData = async (
    pageNo = 1,
    tab,
    viewType = "grid",
    sizePage = 10,
    searchVal = ""
  ) => {
    let finalStatus;

    if (viewType === "grid" && page === 1) {
      setLoader(true);
    }
    if (viewType === "pdf") {
      setPdfLoader(true);
    }
    if (viewType === "excel") {
      setExcelLoader(true);
    }

    if (controllerRef.current) {
      console.log("Aborting previous request...");
      controllerRef.current.abort();
    }

    const thisController = new AbortController();
    controllerRef.current = thisController;
    console.log("New controller created");

    if (localStorage.getItem("activeTab")) {
      finalStatus = localStorage.getItem("activeTab");
    } else {
      finalStatus = tab;
    }

    let payloadValue = {
      status: finalStatus,
      pageSize: sizePage,
      pageNo: pageNo,
      type: filterData,
      fileType: viewType,
      searchKey: searchVal,
      fromDt: fromDate,
      toDt: toDate,
    };
    let encPayload = AESEncryption(payloadValue);    
    try {
      const getOnboardingDetails = await axiosInstance.post(
        Onboarding_Page.OnbOarding_URL_NEW,
        `"${encPayload}"`,
        // payloadValue,
        {
          signal: controllerRef.current.signal,
        }
      );
      const res = ApiResDecrypt(getOnboardingDetails?.data);
      // const res = getOnboardingDetails?.data;
      if (res?.status === 0) {
        
        setServerError(false);
        if (viewType === "grid") {
          setTotalCount(res?.data?.totalcount);
          if (res?.data?.all.length > 0) {
            setServerError(false);
            if (pageNo > 1) {
              setOnboardingData((prev) => {
                return [...prev, ...res?.data.all];
              });
            } else {
              setOnboardingData(res?.data.all);
            }
          } else {
            setOnboardingData(res?.data.all);
            setServerError("No Data Found");
          }
        }

        if (viewType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
        if (viewType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        if (viewType !== "grid") {
          toast.error(res?.message);
        } else {
          setOnboardingData([]);
          setServerError(res?.message);
        }
      }
    } catch (error) {
      setServerError(error?.message);
    } finally {
      if (!thisController.signal.aborted) {
        setLoader(false);
      }
      setScrollLoader(false);
      setExcelLoader(false);
      setPdfLoader(false);
    }
  };

  //REJECTED API DATAAA
  const rejectedOnboardingData = async (
    pageNo = 1,
    tab,
    viewType = "grid",
    sizePage = 10,
    searchVal = ""
  ) => {
    let finalStatus;

    if (viewType === "grid" && page === 1) {
      setLoader(true);
    }
    if (viewType === "pdf") {
      setPdfLoader(true);
    }
    if (viewType === "excel") {
      setExcelLoader(true);
    }

    if (controllerRef.current) {
      console.log("Aborting previous request...");
      controllerRef.current.abort();
    }

    const thisController = new AbortController();
    controllerRef.current = thisController;
    console.log("New controller created");

    if (localStorage.getItem("activeTab")) {
      finalStatus = localStorage.getItem("activeTab");
    } else {
      finalStatus = tab;
    }

    let payloadValue = {
      status: finalStatus,
      pageSize: sizePage,
      pageNo: pageNo,
      type: filterData,
      fileType: viewType,
      searchKey: searchVal,
      fromDt: fromDate,
      toDt: toDate,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getRejectedDetails = await axiosInstance.post(
        Onboarding_Page.RejectedOnboarding_URL,
        `"${encPayload}"`,
        //payloadValue,
        {
          signal: controllerRef.current.signal,
        }
      );
      const res = ApiResDecrypt(getRejectedDetails?.data);
      //const res = getRejectedDetails?.data;
      if (res?.status === 0) {
        setServerError(false);
        if (viewType === "grid") {
          setTotalCount(res?.data?.totalcount);
          if (res?.data?.all.length > 0) {
            setServerError(false);
            if (pageNo > 1) {
              setRejectedData((prev) => {
                return [...prev, ...res?.data.all];
              });
            } else {
              setRejectedData(res?.data.all);
            }
          } else {
            setRejectedData(res?.data.all);
            setServerError("No Data Found");
          }
        }

        if (viewType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
        if (viewType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        if (viewType !== "grid") {
          toast.error(res?.message);
        } else {
          setOnboardingData([]);
          setServerError(res?.message);
        }
      }
    } catch (error) {
      setOnboardingData([]);
      setServerError(error?.message);
    } finally {
      if (!thisController.signal.aborted) {
        setLoader(false);
      }
      setScrollLoader(false);
      setExcelLoader(false);
      setPdfLoader(false);
    }
  };

  //PENDING API DATA
  const pendingOnboardingData = async (
    pageNo = 1,
    tab,
    viewType = "grid",
    sizePage = 10,
    searchVal = ""
  ) => {
    let finalStatus;

    if (viewType === "grid" && page === 1) {
      setLoader(true);
    }
    if (viewType === "pdf") {
      setPdfLoader(true);
    }
    if (viewType === "excel") {
      setExcelLoader(true);
    }

    if (controllerRef.current) {
      console.log("Aborting previous request...");
      controllerRef.current.abort();
    }

    const thisController = new AbortController();
    controllerRef.current = thisController;
    console.log("New controller created");

    if (localStorage.getItem("activeTab")) {
      finalStatus = localStorage.getItem("activeTab");
    } else {
      finalStatus = tab;
    }

    let payloadValue = {
      status: finalStatus,
      pageSize: sizePage,
      pageNo: pageNo,
      type: filterData,
      fileType: viewType,
      searchKey: searchVal,
      fromDt: fromDate,
      toDt: toDate,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const getPendingDetails = await axiosInstance.post(
        Onboarding_Page.PendingOnboarding_URL,
        `"${encPayload}"`,
        //payloadValue,
        {
          signal: controllerRef.current.signal,
        }
      );
      const res = ApiResDecrypt(getPendingDetails?.data);
      //const res = getPendingDetails?.data;
      if (res?.status === 0) {
        setServerError(false);
        if (viewType === "grid") {
          setTotalCount(res?.data?.totalcount);
          if (res?.data?.all.length > 0) {
            setServerError(false);
            if (pageNo > 1) {
              setPendingData((prev) => {
                return [...prev, ...res?.data.all];
              });
            } else {
              setPendingData(res?.data.all);
            }
          } else {
            setPendingData(res?.data.all);
            setServerError("No Data Found");
          }
        }

        if (viewType === "excel") {
          window.open(res?.data, "_self", "noopener,noreferrer");
        }
        if (viewType === "pdf") {
          window.open(res?.data, "_blank", "noopener,noreferrer");
        }
      } else {
        if (viewType !== "grid") {
          toast.error(res?.message);
        } else {
          setPendingData([]);
          setServerError(res?.message);
        }
      }
    } catch (error) {
      setServerError(error?.message);
    } finally {
      if (!thisController.signal.aborted) {
        setLoader(false);
      }
      setScrollLoader(false);
      setExcelLoader(false);
      setPdfLoader(false);
    }
  };

  // for pagination start

  const handleScroll = async (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      const nextPage = page + 1;
      const totalLoadedRecords = page * 10;
      if (
        totalCount > totalLoadedRecords &&
        totalCount !== onboardingData.length
      ) {
        setPage((prev) => prev + 1);
        setScrollLoader(true);
        setLoader(false);
      }
    }
  };

  // for pagination end

  useEffect(() => {
    if (localStorage.getItem("activeTab")) {
      setTabStatus(localStorage.getItem("activeTab"));
    }
  }, [page, tabStatus]);

  function updateStatus(res) {
    setOnboardingData(res);
  }

  function handleTabStatus(status) {
    setTabStatus(status);
    setPage(1);
    setSearch("");
    localStorage.setItem("statusOfClient", tabStatus);
    localStorage.setItem("activeTab", status);
  }

  const handleOnChange = (e) => {
    setPage(1);
    setTabStatus("Created");
    if (e.target.value) {
      setFilterData(e.target.value);
      setOnboardingData([]);
      setSearch("");
    }
  };
  const handleSearch = (val) => {
    if (val?.length > 0) {
      if (tabStatus === "Created" || tabStatus === "Leads")
        onboardingApiData(1, tabStatus, "grid", -1, val);

      if (tabStatus === "Rejected")
        rejectedOnboardingData(1, tabStatus, "grid", -1, val);

      if (tabStatus === "Pending")
        pendingOnboardingData(1, tabStatus, "grid", -1, val);
    }
  };

  const handleOnClick = (e) => {
    if (e.target.value) {
      if (tabStatus === "Created" || tabStatus === "Leads")
        onboardingApiData(1, tabStatus, e.target.value, -1, search);

      if (tabStatus === "Rejected")
        rejectedOnboardingData(1, tabStatus, e.target.value, -1, search);

      if (tabStatus === "Pending")
        pendingOnboardingData(1, tabStatus, e.target.value, -1, search);
    }
  };

  const handleFilterChange = (e) => {
    setPage(1);

    if (e?.target?.value !== "custom-range") {
      setDayWiseDate(e?.target?.value);
    } else {
      setDayWiseDate("custom-range");
      setFromDate("");
      setToDate("");
      setCustomDate(true);
    }
  };

  function getDateRange(filter) {
    let fromDate, toDate;

    switch (filter) {
      case "yesterday":
        fromDate = moment().subtract(1, "days").startOf("day");
        toDate = moment().subtract(1, "days").endOf("day");
        break;

      case "this-week":
        fromDate = moment().startOf("week");
        toDate = moment().endOf("week");
        break;

      case "last-week":
        fromDate = moment().subtract(1, "weeks").startOf("week");
        toDate = moment().subtract(1, "weeks").endOf("week");
        break;

      case "this-month":
        fromDate = moment().startOf("month");
        toDate = moment().endOf("month");
        break;

      case "last-month":
        fromDate = moment().subtract(1, "months").startOf("month");
        toDate = moment().subtract(1, "months").endOf("month");
        break;

      case "till-date":
        fromDate = "";
        toDate = moment();
        break;

      default:
        fromDate = moment();
        toDate = moment();
        break;
    }

    return {
      fromDate: fromDate ? fromDate.format("MM-DD-YYYY") : "",
      toDate: toDate.format("MM-DD-YYYY"),
    };
  }

  function SubmitButton() {
    if (fromDate && toDate) {
      return (
        <button
          type="button"
          className="rej-btn "
          onClick={() => {
            if (tabStatus === "Created" || tabStatus === "Leads")
              onboardingApiData(1, tabStatus, "grid", 10);

            if (tabStatus === "Rejected")
              rejectedOnboardingData(1, tabStatus, "grid", 10);

            if (tabStatus === "Pending")
              pendingOnboardingData(1, tabStatus, "grid", 10);

            setCustomDate(false);
            setFromDate("");
            setToDate("");
          }}
        >
          Submit
        </button>
      );
    } else {
      return (
        <button type="button" className="rej-btn" disabled>
          Submit
        </button>
      );
    }
  }

  return (
    <>
      <Header portal={"RM"} />
      {/* <Sidebar /> */}
      <SingleSignOnSideBar />
      <main id="main-content" className="onboarding-pending">
        <div className="card-right card-tabs">
          <div className="dropdown-filter">
            <Form.Select
              size="lg"
              aria-label="Default select example"
              onChange={handleOnChange}
              value={filterData}
            >
              <option value="HNI">HNI</option>
              <option value="Retail">Retail</option>
            </Form.Select>
          </div>
        </div>

        <div className="tab-content" id="myTabContent">
          <Tab.Container id="left-tabs-example" activeKey={tabStatus}>
            {/* page tabs */}
            <div>
              <Nav variant="nav tabs page-tabs">
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("Created")}
                >
                  <Nav.Link eventKey="Created">{Constants.Created}</Nav.Link>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("Pending")}
                >
                  <Nav.Link eventKey="Pending">{Constants.Pending}</Nav.Link>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("Leads")}
                >
                  <Nav.Link eventKey="Leads">{Constants.Submitted}</Nav.Link>
                </li>

                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("Rejected")}
                >
                  <Nav.Link eventKey="Rejected">{Constants.Rejected}</Nav.Link>
                </li>
                {/* <li
                  className="nav-item"
                  onClick={() => handleTabStatus("NotInterested")}
                >
                  <Nav.Link eventKey="NotInterested">
                    {Constants.NotInterested}
                  </Nav.Link>
                </li>
                <li
                  className="nav-item"
                  onClick={() => handleTabStatus("RaiseIssue")}
                >
                  <Nav.Link eventKey="RaiseIssue">
                    {Constants.Raise_Issue}
                  </Nav.Link>
                </li> */}
              </Nav>
            </div>
            {/* page tabs end */}

            {/* page search and filters start ,menu */}
            <div className="onboarding-secondary-tab-list">
              <div className="search-box"></div>

              <div className="menu-rank-wrapper">
                {tabStatus !== "created" && (
                  <div className="form-group" id="search-onboarding">
                    <div className="for-position">
                      <input
                        type="text"
                        name="search-text"
                        id="SearchInput"
                        className="input-st onboarding"
                        placeholder="Search here..."
                        autoComplete="off"
                        value={search}
                        // handleSearch(e);
                        onInput={(e) => {
                          const start = e.target.selectionStart;
                          const end = e.target.selectionEnd;

                          let input = e.target.value.toUpperCase();
                          input = input.replace(/[^a-zA-Z0-9 ]/g, "");
                                  input = input.replace(/\s{2,}/g, " "); 
                                  input = input.replace(/^\s+/, ""); 

                          if (input.length > 100) input = input.slice(0, 100);
                          e.target.value = input;
                           setSearch(input)
                          e.target.setSelectionRange(start, end);
                        }}
                        // onChange={(e) => {
                        //   setSearch(e.target.value.toUpperCase());
                        // }}
                      />
                    </div>
                  </div>
                )}
                <div className="menu-wrapper">
                  <span
                    className="icon-block-menu"
                    onClick={handleGridView}
                  ></span>
                  <span
                    className="icon-horizontal-menu"
                    onClick={handleListView}
                  ></span>
                </div>
                <div className="onBoarding-Excel-Pdf">
                  <div className="btn-wrapper-summary">
                    <button
                      value="excel"
                      onClick={handleOnClick}
                      className="summary-btn excel-btn"
                    >
                      {smallLoaderExcel ? (
                        <div>
                          <SmallLoader />
                        </div>
                      ) : (
                        <>
                          <span className="icon-excelsvg"></span>
                          Excel
                        </>
                      )}
                    </button>
                    <button
                      className="summary-btn pdf-btn"
                      value="pdf"
                      onClick={handleOnClick}
                    >
                      {smallLoaderPdf ? (
                        <div>
                          <SmallLoader />
                        </div>
                      ) : (
                        <>
                          <span className="icon-pdfsvg"></span>
                          PDF
                        </>
                      )}
                    </button>
                  </div>
                </div>

                {/* <div className="filter-btn-wrapper">
                  <Filter tabStatus={tabStatus} updateStatus={updateStatus} />
                </div> */}

                <select
                  onChange={handleFilterChange}
                  value={dayWiseDate}
                  style={{
                    fontSize: "14px",
                    paddingTop: "7px",
                    paddingBottom: "7px",
                  }}
                >
                  <option value="yesterday">Yesterday</option>
                  <option value="this-week">This Week</option>
                  <option value="this-month">This Month</option>
                  <option value="last-week">Last Week</option>
                  <option value="last-month">Last Month</option>
                  <option value="till-date">Till Date</option>
                  <option value="custom-range">Custom Range</option>
                </select>
              </div>
            </div>
            <div className="for-grid-section">
              {loader ? (
                <div className="loader-alignment">
                  <Loader />
                </div>
              ) : (
                <Tab.Content>
                  <OnboardingCreatedClient
                    checkCreatedClient={onboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                    serverError={serverError}
                    filterData={filterData}
                  />
                  <OnboardingPendingCard
                    checkPending={pendingData}
                    linecard={linecard}
                    scrollLoader={scrollLoader}
                    handleScroll={handleScroll}
                    serverError={serverError}
                    filterData={filterData}
                    selectedClient={selectedClient}
                    setSelectedClient={setSelectedClient}
                    handleRedirect={handleRedirect}
                  />
                  <OnboardingLeads
                    checkLeads={onboardingData}
                    linecard={linecard}
                    scrollLoader={scrollLoader}
                    handleScroll={handleScroll}
                    serverError={serverError}
                    filterData={filterData}
                  />
                  {/* <OnboardingCompleted
                    checkCompleted={onboardingData}
                    linecard={linecard}
                    scrollLoader={scrollLoader}
                    handleScroll={handleScroll}
                    serverError={serverError}
                    filterData={filterData}
                  /> */}

                  <OnboardingRejected
                    checkRejected={rejectedData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                    serverError={serverError}
                    filterData={filterData}
                    selectedClient={selectedClient}
                    setSelectedClient={setSelectedClient}
                    handleRedirect={handleRedirect}
                  />
                  {/* <OnboardingNotInterested
                    checkNotInterested={onboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                    serverError={serverError}
                  />
                  <OnboardingRaiseIssue
                    checkRaiseIssue={onboardingData}
                    linecard={linecard}
                    handleScroll={handleScroll}
                    scrollLoader={scrollLoader}
                    serverError={serverError}
                  /> */}
                </Tab.Content>
              )}
            </div>
          </Tab.Container>
        </div>
      </main>

      {customDate && (
        <Modal
          show={customDate}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="setting-model partner-modal-rejection"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header>
            <Modal.Title id="contained-modal-title-vcenter">
              <h2 className="model-title">Custom Date</h2>
            </Modal.Title>
            <button type="button" className="btn-close" aria-label="Close">
              <span
                className="icon-close"
                onClick={() => setCustomDate(false)}
              ></span>
            </button>
          </Modal.Header>
          <Modal.Body>
            <div className="custom-modal-wrapper row">
              <div className="col-md-6 ">
                <label className="form-label">From Date</label>
                <input
                  type="date"
                  placeholder="DD/MM/YYYY"
                  className="form-input"
                  onChange={(e) =>
                    setFromDate(moment(e?.target?.value).format("MM-DD-YYYY"))
                  }
                />
              </div>
              <div className="col-md-6">
                <label className="form-label">To Date</label>
                <input
                  type="date"
                  placeholder="DD/MM/YYYY"
                  className="form-input"
                  onChange={(e) =>
                    setToDate(moment(e?.target?.value).format("MM-DD-YYYY"))
                  }
                />
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <SubmitButton />
          </Modal.Footer>
        </Modal>
      )}
    </>
  );
}

export default OnboardingPendingNew;
